import "reflect-metadata";

export const labelKey = Symbol("label");
export const labeledPropertiesKey = Symbol("labeledProperties")
const descKey = Symbol("desc");

export function label(label: string) {
    return function (target: any, propertyKey: string) {
        if (!Reflect.hasMetadata(labeledPropertiesKey, target)) {
            Reflect.defineMetadata(labeledPropertiesKey, [], target);
        }

        const properties: string[] = Reflect.getMetadata(labeledPropertiesKey, target);
        properties.push(propertyKey);
        Reflect.defineMetadata(labelKey, label, target, propertyKey);
    }
}

export function getLabel(target: any, propertyKey: string): string | undefined {
    return Reflect.getMetadata(labelKey, target, propertyKey);
}

export function getLabeledProperties(target: any): string[] {
    return Reflect.getMetadata(labeledPropertiesKey, target);
}

export function desc(desc: string) {
    return function (target: any, propertyKey: string) {
        Reflect.defineMetadata(descKey, desc, target, propertyKey);
    }
}

export function getDesc(target: any, propertyKey: string): string {
    return Reflect.getMetadata(descKey, target, propertyKey);
}